





























import Vue from 'vue';
import vSelect from 'vue-select';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Step',
  components: {
    vSelect
  },
  computed: {
    ...mapGetters(['semiTonesArray']),
    isSelected: {
      get() {
        return this.step.selected;
      },
      set(stepSelected) {
        if (stepSelected) {
          (this as any).addStep();
          return;
        }

        (this as any).modifyStep('selected', false);
      }
    },
    key: {
      get(): string {
        return this.step.key;
      },
      set(key: string) {
        (this as any).modifyStep('key', key);
      }
    },
    instrument: {
      get(): string {
        return this.step.instrument;
      },
      set(instrument): void {
        (this as any).modifyStep('instrument', instrument);
      }
    }
  },
  methods: {
    modifyStep(action: string, value: [string, boolean]) {
      this.$store.dispatch('modifyStep', {
        step: this.stepN,
        track: this.track,
        action,
        value
      });
    },
    addStep: function() {
      this.$store.commit('addStep', {
        step: this.stepN,
        track: this.track,
        stepInfo: {
          selected: true,
          animate: false,
          key: this.key,
          instrument: this.instrument
        }
      });
    }
  },
  props: {
    step: [String, Object],
    stepN: Number,
    track: Number,
    instruments: Array
  }
});
